// extracted by mini-css-extract-plugin
module.exports = {"heading":"_tjrhLcgv","container":"_cLl9rVVE","footer":"_78ZSB3EG","gridContainer":"_I0nwAnP_","root":"_RZtGrG6-","radioGroup":"_wDvEbIZW","customAlert":"_UUYhXfjA"};